import { memo } from 'react';
import styled from 'styled-components';

import { AvailabilitySimple } from '@dreryk/egabinet-appointment-frontend-api';

import { TimetableEvent } from '@dreryk/react-calendar';
import { hourMinuteFormatter } from '@dreryk/react-common';
import {
   appendTestableCustomAttribute,
   appendTestableElementAttributes,
   basicCaptionTextStyle,
   basicSmallTextStyle,
   RepeatIcon,
   StyledFlex,
} from '@dreryk/react-components';

import { AvailabilitySourceIcon } from './AvailabilitySourceIcon';

type AvailabilitySlotProps = {
   readonly event: TimetableEvent<AvailabilitySimple>;
};

const AvailabilityTitle = styled.div`
   ${basicSmallTextStyle};
   text-overflow: ellipsis;
   white-space: nowrap;
   overflow: hidden;
`;
AvailabilityTitle.displayName = 'AvailabilityTitle';

const AvailabilityTime = styled.div`
   ${basicCaptionTextStyle};
`;
AvailabilityTime.displayName = 'AvailabilityTime';

const AvailabilityContentRow = styled.div`
   display: flex;
   width: 100%;
   justify-content: space-between;
   align-items: center;
   min-height: 24px;
   padding: 0 5px 0 10px;
`;
AvailabilityContentRow.displayName = 'AvailabilityContentRow';

const IconWrapper = styled.div`
   width: 18px;
   height: 18px;
`;
IconWrapper.displayName = 'IconWrapper';

const RepeatIconWrapper = (): JSX.Element => {
   return (
      <IconWrapper {...appendTestableCustomAttribute('repeat', true)}>
         <RepeatIcon />
      </IconWrapper>
   );
};

const StyledDocplannerLogo = styled.img`
   width: 16px;
   height: 16px;
`;
StyledDocplannerLogo.displayName = 'StyledDocplannerLogo';

const AvailabilitySlot = ({
   event: {
      start,
      end,
      data: { availabilityType, recurring, labels, id },
   },
}: AvailabilitySlotProps): JSX.Element => {
   return (
      <>
         <AvailabilityContentRow {...appendTestableElementAttributes(`availabilityEvent-${id}`)}>
            <AvailabilityTitle {...appendTestableElementAttributes('availabilityType')}>
               {availabilityType.name}
            </AvailabilityTitle>
            <StyledFlex gap={'4px'}>
               {recurring ? <RepeatIconWrapper /> : null}
               {labels.map((label) => (
                  <AvailabilitySourceIcon key={label} sourceLabel={label} />
               ))}
            </StyledFlex>
         </AvailabilityContentRow>
         <AvailabilityContentRow>
            <AvailabilityTime {...appendTestableElementAttributes('time')}>
               {`${hourMinuteFormatter(start)} - 
            ${hourMinuteFormatter(end)}`}
            </AvailabilityTime>
         </AvailabilityContentRow>
      </>
   );
};
const MemoizedAvailabilitySlot = memo(AvailabilitySlot);
export { MemoizedAvailabilitySlot as AvailabilitySlot };
